import React from 'react';

/**
 * Page listing agents within the agency.
 */
export const Agents = () => {
  return (
    <div>
      <h2>Agency Agents</h2>
    </div>
  );
};
